import React from 'react';
import LegalPage from '@/components/LegalPage';

const TermsConditions = () => (
  <LegalPage
    title="Terms and Conditions"
    effectiveDate="September 9, 2025"
    intro="Welcome to Raretto, a brand owned and operated by Rajasthan Trading Co. By accessing or using our website, you agree to comply with and be bound by the following Terms & Conditions. Please read them carefully."
    sections={[
      {
        heading: '1. General Information',
        list: [
          'These Terms govern the use of our website and the purchase of products from Raretto.',
          'By using our website, you agree to follow all applicable laws and these Terms.',
          'We reserve the right to update or modify these Terms at any time without prior notice.',
        ],
      },
      {
        heading: '2. Products & Services',
        list: [
          'We strive to provide accurate descriptions, images, and prices of our products. However, errors may occur, and we reserve the right to correct them.',
          'All products are subject to availability. We may discontinue or limit quantities at any time.',
        ],
      },
      {
        heading: '3. Orders & Payments',
        list: [
          'By placing an order, you agree that all information provided is true and accurate.',
          'Payments must be completed at the time of purchase using our secure payment gateways.',
          'We reserve the right to cancel or refuse any order in case of suspicious activity, stock unavailability, or incorrect pricing.',
        ],
      },
      {
        heading: '4. Shipping & Delivery',
        list: [
          'Orders are processed and shipped as per our Shipping Policy.',
          'Delivery times are estimates and may vary due to external factors.',
          'We are not responsible for delays caused by courier partners, natural events, or circumstances beyond our control.',
        ],
      },
      {
        heading: '5. Returns & Refunds',
        list: [
          'Returns and refunds are handled as per our Refund & Return Policy.',
          'Perishable goods such as chocolates are non-returnable except in cases of damage, defect, or incorrect product.',
        ],
      },
      {
        heading: '6. Intellectual Property',
        list: [
          'All content on this website, including logos, images, text, and product designs, is the property of Rajasthan Trading Co. / Raretto and protected by applicable laws.',
          'You may not copy, reproduce, or distribute our content without prior written permission.',
        ],
      },
      {
        heading: '7. User Conduct',
        paragraphs: ['When using our website, you agree not to:'],
        list: [
          'Misuse the site for fraudulent or unlawful purposes.',
          'Attempt to hack, disrupt, or compromise the security of the website.',
          'Upload harmful or malicious content.',
        ],
      },
      {
        heading: '8. Limitation of Liability',
        list: [
          'Rajasthan Trading Co. / Raretto shall not be held liable for any indirect, incidental, or consequential damages arising from the use of our website or products.',
          'Our maximum liability is limited to the value of the product purchased.',
        ],
      },
      {
        heading: '9. Governing Law',
        list: [
          'These Terms & Conditions are governed by the laws of India.',
          // The original page left this as an unfilled template
          // placeholder ("[Insert City/State]") — using the address given
          // for the footer as a reasonable default. Confirm with whoever
          // handles legal/compliance before treating this as final.
          'Any disputes shall be subject to the jurisdiction of courts located in Mumbai, Maharashtra.',
        ],
      },
      {
        heading: '10. Contact Us',
        paragraphs: ['For any questions regarding these Terms & Conditions, please contact:'],
        list: [
          'Rajasthan Trading Co. (Brand: Raretto), Worli, Mumbai, Maharashtra 400018',
          'Email: customersupport@raretto.com',
          'Phone: +91 91677 98999',
        ],
      },
    ]}
  />
);

export default TermsConditions;
